function login_display() {
    var login = $('#email');
    var pw = $('#login_password');
    var pw_ph = $('#password_ph');
    if(login.val() === '') {
        login.val(language.email_label);
    }
    if(pw.val() !== '') {
        hide_password_ph();
    }
    else {
        pw_ph.val(language.password_label);
        show_password_ph();
    }
}

function toggle_password_ph(display_value) {
    $('#password_ph').css('display', display_value);
    if (display_value == 'none') {
        document.getElementById('login_password').focus();
    }
}
      
function hide_password_ph() {
    toggle_password_ph('none');
}

function show_password_ph() {
    if($('#login_password').val().length < 1) {
        toggle_password_ph('inline');
    }
}
      
function toggle_email(elem, visibility) {
    if(elem != null) {
        switch(visibility) {
            case 'show':
                if(elem.value === '') {
                    elem.value = language.email_label;
                }
            break;
            case 'hide':
                if(elem.value == language.email_label) {
                          elem.value = '';
                }
            break;
        }
    }
}
